<template>
  <CSidebar 
    fixed 
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand>
      <img
        src="img/avatars/preika.png"
        style="cursor: pointer"
        @click="redirectToPage"
      />
    </CSidebarBrand>
    <CRenderFunction flat :content-to-render="navItems" />
  </CSidebar>
</template>

<script>
import axios from "axios";
import nav from "./_nav_clerk";

export default {
  name: "TheSidebar",
  nav,
  data() {
    return {
      navItems: nav,
    };
  },
  mounted() {
    this.fetchSidebarBadges();
  },
  watch: {
    sidebarBadgeRefreshTick() {
      this.fetchSidebarBadges();
    },
  },
  computed: {
    sidebarBadgeRefreshTick() {
      return this.$store.state.sidebarBadgeRefreshTick;
    },
  },
  methods: {
    redirectToPage() {
      window.location.href = "./#/dashboard";
    },
    fetchSidebarBadges() {
      this.fetchSubmissionListCount();
      this.fetchApprovalPendingCount();
    },
    fetchSubmissionListCount() {
      const origin = process.env.VUE_APP_API_ORIGIN;

      return axios
        .get(origin + "/submission/list")
        .then((response) => {
          const count = Array.isArray(response.data) ? response.data.length : 0;
          this.setNavBadgeByTo("/submission_approval/report_list", count);
        })
        .catch((error) => {
          axios
            .get(`${origin}/error/frontError/${error}`)
            .then(() => {})
            .catch(() => {});
          this.setNavBadgeByTo("/submission_approval/report_list", 0);
        });
    },

    // 0件ならバッジを消す / 1件以上なら表示
    setNavBadgeByTo(to, count) {
      const item = this.findNavItemByTo(this.navItems, to);
      if (!item) {
        return;
      }

      const n = Number(count);
      if (!Number.isFinite(n) || n <= 0) {
        this.$set(item, "badge", null);
        return;
      }

      const text = n > 99 ? "99+" : String(n);
      this.$set(item, "badge", {
        color: "danger",
        text: text,
      });
    },

    findNavItemByTo(items, to) {
      if (!Array.isArray(items)) {
        return null;
      }
      for (let i = 0; i < items.length; i++) {
        const it = items[i];
        if (it && it.to === to) {
          return it;
        }
        if (it && Array.isArray(it._children)) {
          const found = this.findNavItemByTo(it._children, to);
          if (found) {
            return found;
          }
        }
      }
      return null;
    },
    // 承認待ち一覧（/document/approval/list）の件数を取得してバッジ更新
    fetchApprovalPendingCount() {
      const origin = process.env.VUE_APP_API_ORIGIN;

      return axios
        .get(origin + "/document/approval/list")
        .then((response) => {
          const count = Array.isArray(response.data) ? response.data.length : 0;
          this.setNavBadgeByTo("/submission_approval/submission_management", count);
        })
        .catch((error) => {
          axios
            .get(`${origin}/error/frontError/${error}`)
            .then(() => {})
            .catch(() => {});

          this.setNavBadgeByTo("/submission_approval/submission_management", 0);
        });
    },
  },
};
</script>
